// extracted by mini-css-extract-plugin
export default {"summaryContainer":"Summary_summaryContainer__grYRV","listContainer":"Summary_listContainer__kwwQD","list":"Summary_list__JUfif","summaryButtons":"Summary_summaryButtons__A+2pz"};